<template>
  <div v-loading="loading">
    <search-input
      placeholder="Поиск по названию"
      style="width: 300px"
      v-model="filters.search"
      @change="filtersChanged"
    >
    </search-input>
    <eval-evaluation-status-select
      v-model="filters.statuses"
      @change="filtersChanged"
    ></eval-evaluation-status-select>
    <div class="evaluation-block">
      <el-table :data="evaluations" border>
        <el-table-column prop="name" label="Название">
          <template v-slot="scope">
            <router-link
              class="table-router-link"
              :to="{ name: 'EvalMyEvaluation', params: { id: scope.row.id } }"
              target="_blank"
            >
              {{ scope.row.name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column width="300" prop="status" label="Статус">
          <template v-slot="scope">
            {{ scope.row.status_label }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadEvaluations"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import EvalEvaluationStatusSelect from "@/modules/evaluation/components/EvalEvaluationStatusSelect.vue";
import SearchInput from "@/components/filters/SearchInput.vue";
import {paginator} from "@/mixins/paginator";

export default {
  name: "my-evaluations-component",
  components: {EvalEvaluationStatusSelect, Paginator, SearchInput},
  mixins: [paginator],
  data() {
    return {
      loading: false,
      evaluations: [],
      filters: {},
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadEvaluations();
  },
  methods: {
    loadEvaluations() {
      this.loading = true;
      this.$api.evaluation.myEvaluationSearch({
        ...this.filters,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluations = data.evaluations;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    filtersChanged() {
      this.loadEvaluations();
    }
  }
}
</script>

<style lang="scss">
  .evaluation-block {
    margin: 25px 0;
  }

  .table-router-link {
    text-decoration: none;
  }
</style>